import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';

@Component({
  selector: 'ip-error-error-404',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error404Component {
  router = inject(Router);

  goToFunds() {
    this.router.navigate(['/']);
  }
}
